import(/* webpackMode: "eager", webpackExports: ["BreadcrumbHomepage"] */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/components/sections/breadcrumb-homepage/BreadcrumbHomepage.tsx");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/node_modules/next/dist/client/link.js");
